import React from "react";
import { Button } from "@mui/material";

const CustomButton = ({ label, color = "primary", variant = "contained", onClick, ...props }) => {
  return (
    <Button color={color} variant={variant} onClick={onClick} {...props}>
      {label}
    </Button>
  );
};

export default CustomButton;

